<template>
    <div class="Nothingbox">
        <!-- -Nothing- -->
        <template v-for="(item, index) in [
            'N',
            'o',
            't',
            'h',
            'i',
            'n',
            'g',
            '.',
            '.',
            '.',
        ]">
            <span class="spanitem">{{ item }}</span>
        </template>
    </div>
</template>

<script setup lang="ts">

</script>

<style lang="less" scoped>
.Nothingbox {
    color: rgba(0, 255, 224, 1);
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    .spanitem {
        width: auto;
        height: auto;
        opacity: 1;
        margin: 1px;
        font-size: 16px;
        border-radius: 100%;
        text-align: center;
        animation: anim 0.7s ease-in-out;
    }

    .spanitem:nth-child(1) {
        animation-delay: 0.5s;
    }

    .spanitem:nth-child(2) {
        animation-delay: 0.7s;
    }

    .spanitem:nth-child(3) {
        animation-delay: 0.9s;
    }

    .spanitem:nth-child(4) {
        animation-delay: 1.1s;
    }

    .spanitem:nth-child(5) {
        animation-delay: 1.3s;
    }

    .spanitem:nth-child(6) {
        animation-delay: 1.5s;
    }

    .spanitem:nth-child(7) {
        animation-delay: 1.7s;
    }

    .spanitem:nth-child(8) {
        animation-delay: 1.9s;
    }

    .spanitem:nth-child(9) {
        animation-delay: 2.1s;
    }

    .spanitem:nth-child(10) {
        animation-delay: 2.3s;
    }

    @keyframes anim {
        75% {
            opacity: 1;
            transform: translateY(-5px);
            // background: rgba(0, 255, 224, 1);
        }

        100% {
            opacity: 1;
            transform: translateY(0px);
        }
    }
}
</style>